import React from "react";
import { QqBundleService } from "../../services/qq-bundle.service";
import { StateDispatchProps } from "../state-dispatch.props";

export type QqSelectedResultsContainerProps = StateDispatchProps & {
  values: { [key: string]: string[] };
  currentOptions: { [key: string]: string };
};

export const QqSelectedResultsRawContainerComponent: React.FunctionComponent<QqSelectedResultsContainerProps> =
  ({ state, values, currentOptions }) => {
    const qqBundleServices = new QqBundleService(state.qqBundle);

    const recommendations =
      qqBundleServices.getFinalRecommendationIfExist(values, currentOptions) ??
      qqBundleServices.getRecommendations(values, currentOptions);

    return (
      <table style={{ display: "block" }}>
        <thead
          style={{
            backgroundColor: "gray",
            color: "white",
            textAlign: "center",
          }}
        >
          <tr>
            <td>Field Name</td>
            <td>Value/Range</td>
            <td>Corresponding Family</td>
          </tr>
        </thead>
        <tbody>
          {Object.keys(currentOptions).map((x) => {
            const qq = qqBundleServices.getControl(x);
            return (
              <tr>
                <td style={{ border: "1px solid black" }}>{qq?.text} </td>
                <td style={{ border: "1px solid black" }}>
                  {currentOptions[x]}
                  {qq?.final && qq.final.indexOf(currentOptions[x]) > -1 ? (
                    <span style={{ color: "red" }}>
                      &nbsp;<b>[final]</b>
                    </span>
                  ) : undefined}
                </td>
                <td style={{ border: "1px solid black" }}>
                  {values[x] !== undefined &&
                  Array.isArray(values[x]) &&
                  values[x].length > 0
                    ? JSON.stringify(values[x])
                    : undefined}
                </td>
              </tr>
            );
          })}
          <tr>
            <td
              style={{
                border: "1px solid black",
                backgroundColor: "lightblue",
                textAlign: "right",
                padding: "14px",
              }}
            >
              Recommendation:{" "}
            </td>
            <td
              style={{
                border: "1px solid black",
                backgroundColor: "lightblue",
                textAlign: "center",
                padding: "14px",
              }}
              colSpan={2}
            >
              {JSON.stringify(recommendations.recommendation)}
            </td>
          </tr>
          <tr>
            <td
              style={{
                border: "1px solid black",
                backgroundColor: "lightblue",
                textAlign: "right",
                padding: "14px",
              }}
            >
              Also Good:{" "}
            </td>
            <td
              style={{
                border: "1px solid black",
                backgroundColor: "lightblue",
                textAlign: "center",
                padding: "14px",
              }}
              colSpan={3}
            >
              {JSON.stringify(recommendations.alsoGood)}
            </td>
          </tr>
        </tbody>
      </table>
    );
  };
